import { render, staticRenderFns } from "./Mediums.vue?vue&type=template&id=090170f0&"
import script from "./Mediums.vue?vue&type=script&lang=js&"
export * from "./Mediums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports